<script>
import {defineComponent, provide} from "vue"
import {storeToRefs} from "pinia"
import {useLayoutsStore} from "@/composables/layouts";

export default defineComponent({
  setup() {
    const layoutStore = useLayoutsStore();
    const {layouts, switchLayout} = storeToRefs(layoutStore);

    provide(
        'changeLayout',
        layoutStore.changeLayout
    );

    return {
      layouts,
      switchLayout
    };
  }
})
</script>

<template>
  <router-view/>
</template>